import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const buyers = [{
  name: 'Lucas G.',
  location: 'Buenos Aires',
  pack: 'Pack Completo'
}, {
  name: 'Martina S.',
  location: 'Rosario',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Federico A.',
  location: 'Córdoba',
  pack: 'Pack Completo'
}, {
  name: 'Camila R.',
  location: 'Mendoza',
  pack: 'Pack Completo'
}, {
  name: 'Diego P.',
  location: 'La Plata',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Sofía M.',
  location: 'Mar del Plata',
  pack: 'Pack Completo'
}, {
  name: 'Nicolás T.',
  location: 'Tucumán',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Valentina B.',
  location: 'Salta',
  pack: 'Pack Completo'
}, {
  name: 'Joaquín C.',
  location: 'Neuquén',
  pack: 'Pack Completo'
}, {
  name: 'Florencia D.',
  location: 'San Juan',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Matías L.',
  location: 'Bahía Blanca',
  pack: 'Pack Completo'
}, {
  name: 'Agustina V.',
  location: 'Santa Fe',
  pack: 'Pack Completo'
}, {
  name: 'Tomás H.',
  location: 'Mendoza',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Julieta F.',
  location: 'Posadas',
  pack: 'Pack Completo'
}, {
  name: 'Bruno K.',
  location: 'Resistencia',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Micaela O.',
  location: 'San Luis',
  pack: 'Pack Completo'
}, {
  name: 'Gonzalo E.',
  location: 'Paraná',
  pack: 'Pack Completo'
}, {
  name: 'Carolina N.',
  location: 'Río Cuarto',
  pack: 'Crossfit Resuelto'
}, {
  name: 'Ezequiel U.',
  location: 'Bariloche',
  pack: 'Pack Completo'
}, {
  name: 'Antonella J.',
  location: 'Corrientes',
  pack: 'Pack Completo'
}];
const timeAgoOptions = ['hace 2 minutos', 'hace 4 minutos', 'hace 7 minutos', 'hace 12 minutos', 'hace 18 minutos', 'hace 25 minutos', 'hace 1 minuto', 'hace 9 minutos', 'hace 15 minutos'];
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<((typeof buyers)[0] & {
    timeAgo: string;
  }) | null>(null);
  useEffect(() => {
    let cycleTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showNext = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      const timeAgo = timeAgoOptions[Math.floor(Math.random() * timeAgoOptions.length)];
      setCurrent({
        ...buyer,
        timeAgo
      });
      setVisible(true);
      // Hide after 6 seconds
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 6000);
      // Schedule next pop in 40-60s after hide
      const nextDelay = 6000 + Math.floor(Math.random() * 20000) + 40000;
      cycleTimeout = setTimeout(showNext, nextDelay);
    };
    // First popup after 8 seconds
    const initial = setTimeout(showNext, 8000);
    return () => {
      clearTimeout(initial);
      clearTimeout(cycleTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-316">
      {visible && current && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] sm:max-w-sm" data-id="element-317">
          <div className="bg-cf-card border border-cf-gold/40 rounded-lg shadow-2xl p-3 md:p-4 flex items-start gap-3 backdrop-blur-sm" data-id="element-318">
            <div className="bg-cf-gold/15 p-2 rounded-full shrink-0" data-id="element-319">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-cf-gold" data-id="element-320" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-321">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-322">
                <span className="text-[10px] md:text-xs font-bold text-cf-gold uppercase tracking-wider" data-id="element-323">
                  Venta verificada
                </span>
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" data-id="element-324" />
              </div>
              <p className="text-sm md:text-base text-white font-semibold leading-tight" data-id="element-325">
                {current.name} — {current.location}
              </p>
              <p className="text-xs md:text-sm text-gray-400 mt-0.5" data-id="element-326">
                Compró el{' '}
                <span className="text-cf-gold font-medium" data-id="element-327">{current.pack}</span>
              </p>
              <p className="text-[10px] md:text-xs text-gray-500 mt-1" data-id="element-328">
                {current.timeAgo}
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-gray-500 hover:text-white shrink-0 transition-colors" aria-label="Cerrar" data-id="element-329">
              <X className="w-4 h-4" data-id="element-330" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}